// src/App.js

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";

import Home from "./pages/Home";

import Signup from "./pages/Signup";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";

import CreatorDashboard from "./pages/CreatorDashboard";
import CreatorAnalytics from "./pages/CreatorAnalytics";

import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";

import ProductPage from "./pages/ProductPage";
import ProductsPage from "./pages/ProductsPage";

import TwitterSuccess from "./pages/TwitterSuccess";
import BuyerDashboard from "./pages/BuyerDashboard";

import BookingSuccess from "./pages/BookingSuccess";
import BookingPage from "./pages/BookingPage";

import SupportPage from "./pages/SupportPage";
import SupportSuccess from "./pages/SupportSuccess";
import PublicSupportPage from "./pages/PublicSupportPage";
import Withdraw from "./pages/Withdraw";
import AdminWithdrawDashboard from "./pages/AdminWithdrawDashboard";
import ContestPage from "./pages/ContestPage";
import AdminContestPage from "./pages/AdminContestPage";
import ProfileSettings from "./pages/ProfileSettings";
import CreatorProfile from "./pages/CreatorProfile";
import HomeGrowth from "./pages/HomeGrowth";



import CreatorStudio from "./pages/CreatorStudio";

function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <Routes>
        {/* 🔥 CORE */}
        <Route path="/" element={<Home />} />
        <Route path="/growth" element={<HomeGrowth />} />
        <Route path="/dashboard" element={<CreatorDashboard />} />
        <Route path="/analytics" element={<CreatorAnalytics />} />
        <Route path="/home" element={<Home />} />

        {/* AUTH */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        

        {/* PRODUCTS */}
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/product/:id" element={<ProductPage />} />

        {/* PAYMENTS */}
        <Route path="/checkout/:id" element={<Checkout />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />

        {/* SUPPORT (🔥 CLEAN + ONLY ONE ROUTE) */}
        <Route path="/support-success" element={<SupportSuccess />} />
        <Route path="/support/:slug/:packageType" element={<SupportPage />} />
        <Route path="/support/:slug" element={<PublicSupportPage />} />
        <Route path="/studio" element={<CreatorStudio />} />
        <Route path="/withdraw" element={<Withdraw />} />
        <Route path="/admin/withdraw" element={<AdminWithdrawDashboard />} />

        {/* BOOKINGS */}
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/booking-success" element={<BookingSuccess />} />

        {/* BUYER */}
        <Route path="/buyerdashboard" element={<BuyerDashboard />} />

        {/* TWITTER */}
        <Route path="/twitter/success" element={<TwitterSuccess />} />
        
        {/* CONTEST */}
        <Route path="/contest" element={<ContestPage />} />
        <Route path="/admin/contest" element={<AdminContestPage />} />
        
        {/* PROFILE */}
        <Route path="/profile/settings" element={<ProfileSettings />} />
        <Route path ="/creator/:displayName" element={<CreatorProfile />} />
      </Routes>


    </BrowserRouter>
  );
}

export default App;